// course_dates.js

// Inizializza tutti i container alla prima apertura pagina e a ogni cambio variante
document.addEventListener('DOMContentLoaded', initCourseDates);
document.addEventListener('variant:change',    initCourseDates);

function initCourseDates() {
  document
    .querySelectorAll('.collapsible-container[data-course-days]')
    .forEach(container => renderCourseDates(container));
}

function renderCourseDates(container) {
  const rawData    = container.dataset.courseDays || '';
  const courseDays = rawData.split(',').map(n => parseInt(n, 10)).filter(n => !isNaN(n));

  const isItalian = document.documentElement.lang.startsWith('it');
  moment.locale(isItalian ? 'it' : 'en');

  const dateTextEl   = container.querySelector('.course-dates-text');
  const customTextEl = container.querySelector('.custom-content-text');
  const listEl       = container.querySelector('.course-dates-list');
  if (!dateTextEl || !customTextEl || !listEl) return;

  // Setup per nomi giorni, festività e cutoff
  const weekdayNames = isItalian
    ? ['Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato','Domenica']
    : ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

  const holidays = [
    '01-01','01-06','04-25','05-01','06-02',
    '08-15','11-01','12-08','12-25','12-26'
  ];
  const excludeBefore = moment('2024-09-10');

  function isHoliday(date) {
    return holidays.includes(date.format('MM-DD'));
  }
  function isExcluded(date) {
    return date.isSameOrBefore(excludeBefore);
  }
  function getNextDates(days, count) {
    const result = [];
    let d = moment();
    while (result.length < count) {
      d.add(1, 'day');
      const wd = d.isoWeekday();
      if (
        days.includes(wd) &&
        !isHoliday(d) &&
        !isExcluded(d)
      ) {
        result.push(d.clone());
      }
    }
    return result;
  }
  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  function formatWeekdays(days) {
    const sep = isItalian ? ' e ' : ' and ';
    return days.map(d => weekdayNames[d - 1]).join(sep);
  }

  // Se il corso è “0” = personalizzato
  if (courseDays.includes(0)) {
    dateTextEl.innerHTML = isItalian
      ? 'Il corso è soggetto a prenotazione. <a href="link-prenotazione">Clicca qui per saperne di più</a>.'
      : 'This course requires reservation. <a href="link-prenotazione">Click here to learn more</a>.';

    customTextEl.innerHTML = isItalian
      ? 'Contattaci per organizzare una data personalizzata.'
      : 'Contact us to arrange a personalized date.';

    listEl.style.display = 'none';
    return;
  }

  // Altrimenti, date standard
  const nextDates = getNextDates(courseDays, 2);
  const firstDate  = capitalize(nextDates[0].format('dddd D MMMM'));
  const secondDate = capitalize(nextDates[1].format('dddd D MMMM'));

  dateTextEl.innerHTML = isItalian
    ? `Prossime date per i corsi sono <strong>${firstDate}</strong> e/o <strong>${secondDate}</strong>.`
    : `Next course dates are <strong>${firstDate}</strong> and/or <strong>${secondDate}</strong>.`;

  const readableDays = formatWeekdays(courseDays).toUpperCase();
  customTextEl.innerHTML = isItalian
    ? `Il corso si svolge, a patto di raggiungere il numero di iscritti minimo, ossia 4, di base ogni ${readableDays} (Tuttavia, se vorreste un giorno diverso, o se siete già un gruppo da 4 o più e volete farlo in una data non disponibile, potete contattarci per organizzare una data personalizzata. I costi sono gli stessi, non ci saranno sovrapprezzi).`
    : `The course is held, provided a minimum of 4 participants is reached, usually every ${readableDays} (However, if you'd like a different day, or if you're already a group of 4 or more and want to schedule it on a different date, feel free to contact us to organize a custom session. The cost is the same, with no extra fees).`;

  // Costruzione calendario per i prossimi 2 mesi
  const start = moment().startOf('month');
  const end   = moment().add(2, 'months').endOf('month');
  const all   = getNextDates(courseDays, 60).filter(d =>
    d.isSameOrAfter(start) && d.isSameOrBefore(end)
  );

  const grouped = all.reduce((acc, d) => {
    const m = capitalize(d.format('MMMM YYYY'));
    if (!acc[m]) acc[m] = [];
    acc[m].push(capitalize(d.format('dddd D MMMM')));
    return acc;
  }, {});

  // Render lista
  let html = '';
  for (const month in grouped) {
    html += `<div class="month-title">${month}</div><ul class="date-list">`;
    grouped[month].forEach(d => { html += `<li>${d}</li>`; });
    html += `</ul>`;
  }
  listEl.innerHTML = html;
}
